import { useLastLoginProviderStorage } from '@/shared/hooks/useLastLoginProviderStorage';
import { getSafeRedirectUri } from '@/shared/utils/url';
import { LoginProviderEnum } from '@gorgeous/common/enums/users/login-provider.enum';
import { signIn } from 'next-auth/react';
import { useRouter, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';

type Props = {
  setIsLoading: (isLoading: boolean) => void;
};
export const useLoginWithPhone = ({ setIsLoading }: Props) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const { setLastLoginProvider } = useLastLoginProviderStorage();

  const loginWithPhone = useCallback(
    async ({ phoneNumber, verificationCode }: { phoneNumber: string; verificationCode: string }) => {
      setIsLoading(true);
      try {
        const redirectUri = getSafeRedirectUri(searchParams?.get('redirect_uri'));

        const res = await signIn('phone-number', {
          phoneNumber,
          verificationCode,
          redirect: false,
        });

        if (res?.error) {
          alert(res.error);
          setIsLoading(false);
          router.push('/login');
          return;
        }

        setLastLoginProvider(LoginProviderEnum.Phone);
        router.push(redirectUri);
      } catch (_e) {
        alert('ログインに失敗しました');
        setIsLoading(false);
        router.push('/login');
        return;
      }
    },
    [router, setIsLoading, searchParams, setLastLoginProvider],
  );

  return { loginWithPhone };
};
